import { Toaster as Sonner } from 'sonner';

const Toaster = () => {
  return (
    <Sonner
      position="bottom-right"
      toastOptions={{
        style: {
          background: 'white',
          color: 'black',
          border: '1px solid #e5e7eb'
        }
      }}
    />
  );
};

export { Toaster };